import { render, staticRenderFns } from "./CreativeCommonsIcon.vue?vue&type=template&id=242a38e9"
import script from "./CreativeCommonsIcon.vue?vue&type=script&lang=js"
export * from "./CreativeCommonsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports